// extracted by css-extract-rspack-plugin
export default {"header":"PdfEditorOverlayController_header__-ZNkp","goBack":"PdfEditorOverlayController_goBack__mza24"};